import { BaseFieldClass } from './baseField.class'

import { IIntField } from '@/types/serverField.type'

export class IntFieldClass extends BaseFieldClass {
  declare fieldValue: number
  declare initialValue: number

  constructor (field: IIntField) {
    super(field)
    const value = field.Value ?? field.DefaultValue
    this.initialValue = this.prepareValue(value as string | number | null)
    this.fieldValue = this.prepareValue(value as string | number | null)
  }

  prepareValue (value: string | number | null): number {
    return Number(value) || 0
  }

  getValue () {
    return {
      [this.name]: this.fieldValue
    }
  }

  appendToFormData (formData: FormData): void {
    formData.append(this.name, String(this.fieldValue ?? ''))
  }

  getFilterValue () {
    return this.fieldValue
  }
}
